// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__b10Y7","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2Wmo4"};